import { Link } from "react-router-dom";
import { Heart, Facebook, Instagram, Youtube, Mail, Phone, MapPin } from "lucide-react";
import { ORG } from "../data/site";

const QUICK = [
  { label: "About Us", to: "/about" },
  { label: "What We Do", to: "/what-we-do" },
  { label: "Get Involved", to: "/get-involved" },
  { label: "News & Updates", to: "/news" },
  { label: "Contact", to: "/contact" },
];

const SITEMAP = [
  { label: "Donate", to: "/get-involved#donate" },
  { label: "Partner With Us", to: "/get-involved#partner" },
  { label: "Fundraise", to: "/get-involved#fundraise" },
  { label: "Our Team", to: "/about#team" },
  { label: "Transparency & Reports", to: "/about#transparency" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-brand-ink text-brand-cream">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-10">
        <div className="grid gap-12 lg:grid-cols-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="grid place-items-center h-10 w-10 rounded-full bg-brand-accent text-brand-ink">
                <Heart className="h-5 w-5" strokeWidth={2.2} />
              </span>
              <span className="font-serif text-2xl">Equipping New Life</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-brand-cream/70">
              A grassroots charitable society serving the ethnic communities of Bishnupur District, Manipur since 2005.
            </p>
            <div className="mt-8 flex gap-3">
              {[Facebook, Instagram, Youtube].map((Icon, i) => (
                <a key={i} href="#" aria-label="social" data-testid={`social-link-${i}`} className="grid place-items-center h-10 w-10 rounded-full border border-brand-cream/20 hover:border-brand-accent hover:text-brand-accent transition-colors">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-brand-cream/60">Quick Links</h4>
            <ul className="mt-5 space-y-3">
              {QUICK.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-brand-cream/80 hover:text-brand-accent transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Sitemap */}
          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-brand-cream/60">Sitemap</h4>
            <ul className="mt-5 space-y-3">
              {SITEMAP.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-brand-cream/80 hover:text-brand-accent transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-brand-cream/60">Contact</h4>
            <ul className="mt-5 space-y-4 text-sm text-brand-cream/80">
              <li className="flex gap-3"><MapPin className="h-5 w-5 shrink-0 text-brand-accent" /> {ORG.address}</li>
              <li className="flex gap-3"><Phone className="h-5 w-5 shrink-0 text-brand-accent" /> <a href={`tel:${ORG.phone}`} className="hover:text-brand-accent transition-colors">{ORG.phone}</a></li>
              <li className="flex gap-3"><Mail className="h-5 w-5 shrink-0 text-brand-accent" /> <a href={`mailto:${ORG.email}`} className="hover:text-brand-accent transition-colors break-all">{ORG.email}</a></li>
            </ul>
          </div>
        </div>

        {/* Legal / registration */}
        <div className="mt-16 rounded-2xl border border-brand-cream/15 bg-brand-cream/5 p-6 text-sm text-brand-cream/70">
          <p className="font-medium text-brand-cream/90">Registered Charitable Society</p>
          <p className="mt-2 leading-relaxed">
            Registered under the {ORG.regAct} — {ORG.regNo}, dated {ORG.regDate}, issued by the {ORG.regAuthority}.
          </p>
          <p className="mt-2 leading-relaxed">{ORG.certification}</p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-brand-cream/10 pt-6 text-xs text-brand-cream/50">
          <p>© {new Date().getFullYear()} Equipping New Life. All rights reserved.</p>
          <p>Made with care in Thanga, Bishnupur · Manipur</p>
        </div>
      </div>
    </footer>
  );
}
